/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MeritAllocationsTriggerNewHireProcessModel {
  gids?: Array<string> | null;
  seasonType?: MeritAllocationsTriggerNewHireProcessModelSeasonTypeEnum | null;
  seasonId?: string | null;
  isNewHire?: boolean | null;
}
export enum MeritAllocationsTriggerNewHireProcessModelSeasonTypeEnum {
  Unknown = 'Unknown',
  Sog = 'SOG',
  Gbr = 'GBR',
  Merit = 'Merit',
  IncentiveV2 = 'IncentiveV2',
  SpecialPaymentCash = 'SpecialPaymentCash',
  SpecialPaymentEquity = 'SpecialPaymentEquity',
  PositionEvaluation = 'PositionEvaluation',
  Restructuring = 'Restructuring'
}
